import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const INDUSTRIES_QUERY = gql`
  query industries {
    industries {
      key
      value: industry
      imageUrl
      label: industry
      title
      category
    }
  }
`;

function useIndustries({ skipQuery }) {
  const { data, error, loading } = useQuery(INDUSTRIES_QUERY, {
    skip: skipQuery
  });

  useError(error);

  return {
    data: data?.industries || [],
    error,
    loading
  };
}

export default useIndustries;
